import { render, staticRenderFns } from "./message-status-icon.vue?vue&type=template&id=30e99fb7&scoped=true&"
import script from "./message-status-icon.vue?vue&type=script&lang=js&"
export * from "./message-status-icon.vue?vue&type=script&lang=js&"
import style0 from "./message-status-icon.vue?vue&type=style&index=0&id=30e99fb7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e99fb7",
  null
  
)

export default component.exports